export default __webpack_public_path__ + "static/B0021-435b6ad0ea5f1d5948fdfd3400c7a836.png";